import React, { useContext, useEffect, useState } from 'react'
import { format } from 'date-fns'
import { FaFolderOpen } from 'react-icons/fa'
import { useHistory } from 'react-router-dom'

import { Container } from './styles'
import Card from '../../../../components/Card'
import { api, authHeaders } from '../../../../services/api'
import Table from '../../../../components/Table'
import { GlobalContext } from '../../../../contexts/GlobalContext'
import Spinner from '../../../../components/Spinner'

export default function () {
	const { user, checkException } = useContext(GlobalContext)

	const [projetos, setProjetos] = useState(null)

	const history = useHistory()

	async function loadProjetos() {
		try {
			const response = await api.get('projeto', authHeaders())

			setProjetos(response.map(item => ({
				id: item.id,
				nome: item.nome,
				condicao: item.projeto_pessoas.find(pp => pp.pessoa.id === user.pessoa.id)?.funcao.descricao,
				inicio: format(new Date(item.inicio), 'dd/MM/yyyy'),
				fim: format(new Date(item.fim), 'dd/MM/yyyy')
			})))
		} catch (e) {
			checkException(e)
		}
	}

	function handleAbrirProjeto(projeto) {
		history.push(`/projeto/${projeto.id}`)
	}

	useEffect(() => {
		loadProjetos()
	}, [])

	function getHeaders() {
		if(user.perfil.id === 3) {
			return [
				{ name: 'nome', value: 'Projeto' },
				{ name: 'inicio', value: 'Início', centered: true },
				{ name: 'fim', value: 'Fim', centered: true }
			]
		} else {
			return [
				{ name: 'nome', value: 'Projeto' },
				{ name: 'condicao', value: 'Função', centered: true },
				{ name: 'inicio', value: 'Início', centered: true },
				{ name: 'fim', value: 'Fim', centered: true }
			]
		}
	}

	if (!projetos) {
		return (
			<Container>
				<Card>
					<h1>Projetos</h1>
					<Spinner />
				</Card>
			</Container>
		)
	}

	return (
		<Container>
			<Card>
				<h1>Projetos</h1>

				<Table
					headers={getHeaders()}
					data={projetos}
					actions={[
						{
							action: handleAbrirProjeto,
							icon: FaFolderOpen,
							iconSize: 18,
							name: 'Abrir'
						}
					]}
					filterable
				/>
			</Card>
		</Container>
	)
}
